import { arbitrum as viemArbitrum } from 'viem/chains'

import type { AppChain } from './chain.types'

export const arbitrum = {
  ...viemArbitrum,
  custom: {
    name: 'Arbitrum One',
    shortName: 'Arbitrum',
    morphoChainSlug: 'arbitrum',
    hasFullSupport: true,
    blockExplorer: { baseUrl: 'https://arbiscan.io', name: 'Arbiscan' },
    contracts: {
      v1: {
        AdaptiveCurveIrm: {
          address: '0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA',
          startBlock: 296446593n
        },
        MorphoBlue: {
          address: '0x6c247b1F6182318877311737BaC0844bAa518F5e',
          startBlock: 296446593n
        },
        MetaMorphoV11Factory: {
          address: '0x878988f5f561081deEa117717052164ea1Ef0c82',
          startBlock: 296447195n
        }
      },
      v2: {
        VaultV20Factory: {
          address: '0x6b46fa3cc9EBF8aB230aBAc664E37F2966Bf7971',
          startBlock: 387016724n
        },
        MorphoMarketV1AdapterFactory: {
          address: '0x96456Bf888D4de607Bf3ca0b3C8e4DF9b0d0Ad47',
          startBlock: 387016724n
        },
        MorphoMarketV1AdapterV2Factory: {
          address: '0xeF84b1ecEbe43283ec5AF95D7a5c4D7dE0a9859b',
          startBlock: 409152917n
        },
        MorphoVaultV1AdapterFactory: {
          address: '0xD8Fc8a85779551e78B516da9f74061cb3b086793',
          startBlock: 387016724n
        },
        RegistryList: {
          address: '0xc00eb3c7aD1aE986A7f05F5A9d71aCa39c763C65',
          startBlock: 387017701n
        },
        BluePublicAllocator: {
          address: '0x85b66Fe31e6788E5a6825EAe689f4c6c38AF3704',
          startBlock: 495274087n
        }
      }
    }
  }
} as const satisfies AppChain<{ v1: true; v2: true }>
